module.exports = __webpack_public_path__ + "b0e0a1e693b0f3626165a40a5b477123.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-46@2x.png
// module id = 519
// module chunks = 0